if (!customElements.get('infinite-scroll')) {
  class InfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.nextUrl = this.dataset.nextUrl;
      this.sectionId = this.dataset.sectionId;
      this.grid = document.getElementById('product-grid');
      this.loader = this.querySelector('.infinite-scroll__loader');
      this.pagination = this.querySelector('.pagination-wrapper');
      this.loading = false;

      if (!this.nextUrl || !this.grid) return;
      if (this.pagination) this.pagination.hidden = true;

      this.observer = new IntersectionObserver(
        (entries) => { if (entries[0].isIntersecting) this.loadNext(); },
        { rootMargin: '0px 0px 600px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async loadNext() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      this.loader?.removeAttribute('hidden');

      try {
        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        doc.querySelectorAll('#product-grid > li').forEach((li) => this.grid.appendChild(li));

        const next = doc.querySelector('infinite-scroll');
        this.nextUrl = next ? next.dataset.nextUrl : '';

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(this.grid);
        }
      } catch (err) {
        console.error('Infinite scroll failed:', err);
        this.nextUrl = '';
        if (this.pagination) this.pagination.hidden = false; // fall back to normal pagination
      } finally {
        this.loading = false;
        this.loader?.setAttribute('hidden', '');
        if (this.nextUrl) {
          // re-check in case the sentinel is still on screen
          this.observer.unobserve(this);
          this.observer.observe(this);
        } else {
          this.observer?.disconnect();
        }
      }
    }
  }
  customElements.define('infinite-scroll', InfiniteScroll);
}